import React from "react";

const Loader = () => {
  return (
    <div className="d-flex w-100 justify-content-center align-content-center">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
